import React, { useState } from "react";
import { LoginForm } from "../../components/auth/LoginForm";
import { RegistrationForm } from "../../components/auth/RegistrationForm";
import { RegistrationSuccessDialog } from "../../components/auth/RegistrationSuccessDialog";
import { LoginSuccessDialog } from "../../components/auth/LoginSuccessDialog";
import { useAuth } from "../../context/AuthContext";

export const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showRegistrationDialog, setShowRegistrationDialog] = useState(false);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const { setJustRegistered, setJustLoggedIn } = useAuth();

  const handleRegistrationSuccess = () => {
    setShowRegistrationDialog(true);
  };

  const handleLoginSuccess = () => {
    setShowLoginDialog(true);
  };

  const handleCloseSuccessDialog = () => {
    setShowRegistrationDialog(false);
    setJustRegistered(false); // Clear the justRegistered flag
    setIsLogin(true); // Switch back to login form when dialog is closed
  };

  const handleCloseLoginDialog = () => {
    setShowLoginDialog(false);
    setJustLoggedIn(false); // Clear the justLoggedIn flag
  };

  return (
    <div className="min-h-screen bg-[#eeeff6] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Logo and Title */}
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <img
              className="w-16 h-16 object-cover"
              alt="AdapTeach Logo"
              src="/logo.png"
            />
          </div>
          <h2 className="text-2xl font-bold text-[#373e46] mb-2">AdapTeach</h2>
          <p className="text-lg text-[#373e46] font-medium">
            {isLogin ? "Masuk ke Dashboard" : "Pendaftaran Akun"}
          </p>
        </div>

        {/* Auth Forms */}
        <div className="bg-white rounded-3xl shadow-lg p-8">
          {isLogin ? (
            <LoginForm
              onSwitchToRegister={() => setIsLogin(false)}
              onLoginSuccess={handleLoginSuccess}
            />
          ) : (
            <RegistrationForm
              onSwitchToLogin={() => setIsLogin(true)}
              onRegistrationSuccess={handleRegistrationSuccess}
            />
          )}
        </div>
      </div>

      {/* Registration Success Dialog */}
      <RegistrationSuccessDialog
        isOpen={showRegistrationDialog}
        onClose={handleCloseSuccessDialog}
      />

      {/* Login Success Dialog */}
      <LoginSuccessDialog
        isOpen={showLoginDialog}
        onClose={handleCloseLoginDialog}
      />
    </div>
  );
};
